/**
 * Loose text-equality check for deciding whether a heading, section name, or
 * document title all name the same thing.
 *
 * The AI is not consistent about case or spacing across a document name, a
 * section's own heading block, and the taxonomy `sectionName` attached to it
 * server-side, so byte-equality would under-match. Comparison normalizes to
 * trimmed, lowercased text with internal whitespace collapsed to a single
 * space before comparing.
 *
 * Shared by `GeneratedDocumentPreview` (the GENERATE preview) and
 * `ProposedPane` (the REWRITE review pane) — both need to hide a heading that
 * would otherwise print the same name a second time.
 */
export function sameHeading(a?: string | null, b?: string | null): boolean {
  if (!a || !b) return false;
  const norm = (s: string) => s.trim().toLowerCase().replace(/\s+/g, ' ');
  return norm(a) === norm(b);
}
